import ViewModule from './ViewModule';

export default ViewModule;
